import { RepositoryAccessType } from '../CommonConstants';
import { z } from 'zod';

export const GitConfigSchema = z
  .object({
    deploymentID: z.number().int().min(1),
    accessTypeID: z.nativeEnum(RepositoryAccessType),
    gitProviderUserID: z.string(),
    latestConfig: z.any().nullable(),
    timeUpdated: z.date(),
  })
  .strict()
  .nullable();

export type GitConfigDocument = z.infer<typeof GitConfigSchema>;

export const GitConfigUserSchema = z
  .object({
    userID: z.number().int().min(1),
    firstName: z.string(),
    lastName: z.string(),
    username: z.string().nullable(),
    image: z.string(),
  })
  .strict()
  .nullable();

export type GitConfigUserDocument = z.infer<typeof GitConfigUserSchema>;
